import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {BaseurlService} from '../../services/baseurl.service';
import { StracliCmdService, StracliCommandType } from '../stracli-cmd/stracli-cmd.service';

export type AiTool = 'CLAUDE' | 'OPENCODE' | 'QWEN';
export type AiProvider = 'RISE' | 'INSO';

export interface AiCommandDto {
  id: number;
  stracliCommandUid: string;
  created: string;
  responseReceived: string | null;
  command: StracliAiCmd | null;
  response: StracliCmdResponseAi | null;

  gitlabMrActionType: string | null;
  gitlabMrWebUrl: string | null;

  gitlabMrGitlabStatus: string | null;
  gitlabMrStrapiStatus: string | null;
  freeScoutConversationUrl: string | null;
}

export interface StracliAiCmd {
  tool: AiTool;
  aiProvider: AiProvider;
  stdin: string;
  cloneUrl: string | null;
  checkoutCommands: string | null;
  mountRepoReadonly: boolean;
  pushChanges: boolean;
  pushChangesBranch: string | null;
  pushChangesCommitMessage: string | null;
  pushChangesName: string | null;
  pushChangesEmail: string | null;
  forcePush: boolean;
}

export interface StracliCmdResponseAi {
  exitCode: number;
  stdout: string;
  stderr: string;
  terminatedOnItsOwn: boolean;
  gitStatus: string | null;
  gitDiff: string | null;
  pushSuccess: boolean | null;
}

const AI_RETRY_HOST = 'cthulhu';

@Injectable({
  providedIn: 'root'
})
export class AiService {
  constructor(
    private http: HttpClient,
    private baseurlService: BaseurlService,
    private stracliCmdService: StracliCmdService,
  ) {}

  getAiCommands(): Observable<AiCommandDto[]> {
    return this.http.get<AiCommandDto[]>(`${this.baseurlService.getBaseUrl()}/stracliCommands/ai`);
  }

  getAiCommandPerStracliCmdUid(stracliCommandUid: string): Observable<AiCommandDto> {
    return this.http.get<AiCommandDto>(`${this.baseurlService.getBaseUrl()}/stracliCommands/ai/byStracliCmdUid/${stracliCommandUid}`);
  }

  getAiCommandPerStracliCmdUids(stracliCommandUids: string[]): Observable<AiCommandDto[]> {
    return this.http.post<AiCommandDto[]>(`${this.baseurlService.getBaseUrl()}/stracliCommands/ai/byStracliCmdUid`, stracliCommandUids);
  }

  retryAiCommand(command: StracliAiCmd): Observable<void> {
    return this.stracliCmdService.runCommand(AI_RETRY_HOST, StracliCommandType.AI, {text: JSON.stringify(command)});
  }

  deleteAiCommand(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseurlService.getBaseUrl()}/stracliCommands/ai/${id}`);
  }
}
